import { Injectable } from "@angular/core";
import { EstablishmentInfo } from "../sync-prices-cart/interfaces/purchase.interface";

@Injectable({
  providedIn: 'root'
})
export class EstablishmentInfoService {

  private infoEstablishment: EstablishmentInfo = {
    id_products: [],
    id_establishment: 0
  };



  setInfoEstablishment(info: EstablishmentInfo) {
    // console.log('info', info);

    this.infoEstablishment = info;
  }

  getInfoEstablishment() {
    return this.infoEstablishment;
  }
}
